<template>
  <nav>
    <a v-for="(popuppage, index) in getPagesFromPaths(block.content.pages)"
                 :key="index"
                 @click='$router.push({ name: "popup", params: { popup: popuppage.uid, savePosition: savePosition }})' >
      <h2 v-html='popuppage.strings.title' />
      <slot />
    </a>
  </nav>
</template>

<script>
import mixins from '.././mixins.js';
export default {
  mixins: [mixins], //kirby(), urltopath(), etc
  props: ['block'],
  computed: {
    savePosition: function(){
      return window.top.scrollY;
    }
  }
}
</script>

<style scoped>

  nav {
    padding: 1.5rem 0 3rem;
  }

  a {
    display: block;
    border-top: var(--thinline);
    text-decoration: none;
    padding: 0.75rem 0;
    cursor: pointer;
  }

  h2 {
    font-size: 3em;
    padding: 0;
    padding-left: 1.5em;
    position: relative;
    margin: 0;
  }

  h2::before {
    transition: transform 0.15s ease-in-out;
    position: absolute;
    left: 0;
    content: '→ '
  }

  h2:hover::before {
    transform: translateX(0.25em);
  }

</style>
